import state from './state';
import reducers from './reducers';
import effects from './effects';

export const notifications = {
  state,
  reducers,
  effects,
};

export default notifications;
